import { useQuery } from '@tanstack/react-query'
import { getPlanogramSkus } from '@/api/planograms'

export function usePlanogramSkus(pogIds: number[]) {
  return useQuery({
    queryKey: ['planograms', 'skus', pogIds.slice().sort()],
    queryFn: () => getPlanogramSkus(pogIds),
    enabled: pogIds.length > 0,
    staleTime: 0,
  })
}
